'use strict';


export function ProgressService(ViewpointManager) {
  /*@ngInject*/
  var serviceProvider = function() {
    this.progress = {};
    //siteUploadFactor default value is one as there will be always be one things to upload
    this.siteUploadFactor = 1;
    this.progressTotal = 0;

    this.updateProgress = (evt, type) => {
      if(typeof evt !== 'undefined') {
        this.message = this.setProgressMessage(type);
        let eventId = this._idEvent(evt);
        let progressPercentage = parseInt(evt.loaded / evt.total * 100, 10);
        this.progress[eventId] = progressPercentage / this.getProgressFactor();
        this.progressTotal = this.calculateProgress();
      }
    };

    // returns the progressDetails to create/edit controllers to be fed to view
    this.getProgress = () => {
      return {
        value: this.progressTotal,
        message: this.message,
        type: this.progressTotal === 100 ? 'success' : 'warning'
      };
    };

    // set the progress bar valued manually for when we want to jump from 0 to 100/success
    this.setProgress = () => {
      return {
        value: 100,
        message: 'progress.ALL_SAVED_SUCCESSFULLY',
        type: 'success'
      };
    };

    // creating unique hash from event files object for the prgress object
    this._idEvent = evt => {
      let files = evt.config.data.files;
      let stringToHash = '';
      for(let key in files) {
        // key will be the identifier here
        if(_.isObject(files[key])) {
          stringToHash += key + files[key].name + files[key].size + files[key].lastModifiedDate;
        }
      }
      return CryptoJS.SHA256(JSON.stringify(stringToHash)).toString();
    };

    // setting the message shown above progress bar, wether site assets are being uploaded or viewpoints
    this.setProgressMessage = data => {
      let message;
      switch (data) {
      case 'viewpoint':
        message = this.progressTotal >= 100
        ? 'progress.ALL_SAVED_SUCCESSFULLY'
        : 'progress.UPLOADING_VIEWPOINT_ASSETS';
        return message;
      case 'site':
        message = this.progressTotal >= 100
        ? 'progress.ALL_SAVED_SUCCESSFULLY'
        : 'progress.UPLOADING_SITE_ASSETS';
        return message;
      }
    };

    // calculate the progress value
    this.calculateProgress = () => {
      if(Object.keys(this.progress).length <= 0) {
        return 0;
      }
      let progress = 0;

      _.each(this.progress, value => {
        progress += value;
      });
      return progress;
    };

    //calculating the total number of upload peers so the 100 can be divided by this number
    this.getProgressFactor = () => {
      let viewpointsUploadCount = ViewpointManager.getActualViewpointsUploadCount();
      return viewpointsUploadCount + this.siteUploadFactor;
    };
  };

  return {
    instance: () => {
      return new serviceProvider();
    }
  };
}

export default angular.module('fplTruescapeComApp.Progress', [])
  .factory('Progress', ProgressService)
  .name;



// WEBPACK FOOTER //
// ./client/components/Progress/progress.service.js